import { render } from "./DiploTab.vue?vue&type=template&id=73a9e140&scoped=true"
import script from "./DiploTab.vue?vue&type=script&lang=js"
export * from "./DiploTab.vue?vue&type=script&lang=js"

import "./DiploTab.vue?vue&type=style&index=0&id=73a9e140&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a9e140"]])

export default __exports__